'use es6';

import { FetchIrisRequestTypes } from 'pricing-pages-unified-ui/actions/IrisActions';

const Iris = (state = {}, {
  type,
  payload
}) => {
  switch (type) {
    case FetchIrisRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }

    default:
      return state;
  }
};

export default Iris;